import type { Directive } from 'vue';

export default {
  mounted: (element, { value }) => {
    if (value !== false) {
      element.focus();
    }
  },
} satisfies Directive<HTMLInputElement | HTMLTextAreaElement, boolean | undefined>;
